module.exports = __webpack_public_path__ + "img/pin_aibus@3x.028e4184.png";